import BreadcrumbLink from '@/shared/ui/components/BreadcrumbLink';
import { ComingSoon } from '@/shared/ui/components/ComingSoon';
import type { RoutePathDefinition } from '../../types';

export const tcmSectionRoutes: RoutePathDefinition[] = [
  {
    path: 'dashboard',
    lazy: () => import('@/pages/tcm/ui/TcmDashboard').then(m => ({ Component: m.default })),
    handle: { crumb: () => <BreadcrumbLink>Dashboard</BreadcrumbLink> }
  },
  {
    path: 'adt-queue',
    lazy: () => import('@/pages/tcm').then(m => ({ Component: m.AdtQueue })),
    handle: { crumb: () => <BreadcrumbLink>ADT Queue</BreadcrumbLink> }
  },
  {
    path: 'adt-queue-v1',
    lazy: () => import('@/pages/tcm').then(m => ({ Component: m.AdtQueueV1 })),
    handle: { crumb: () => <BreadcrumbLink>ADT Queue</BreadcrumbLink> }
  },
  { path: 'billing', Component: () => <ComingSoon title={'Billing'} />, handle: { crumb: () => <BreadcrumbLink>Billing</BreadcrumbLink> } },
  {
    path: 'tcm-tasks',
    Component: () => <ComingSoon title={'TCM Tasks'} />,
    handle: { crumb: () => <BreadcrumbLink>TCM Tasks</BreadcrumbLink> }
  },
  {
    path: 'discharge',
    lazy: () => import('@/pages/tcm').then(m => ({ Component: m.DischargePatient })),
    handle: { crumb: () => <BreadcrumbLink>Discharge Patients</BreadcrumbLink> }
  }
];
